import primaryButtonHover from '../../../../../common/algorithms/primary-button-hover';

const custom = (params) => primaryButtonHover(params, false);

export default custom;
